/**
 * Cart drawer: "Switch to Subscribe & save" for one-time items that have a subscription plan.
 * Changes the line's selling plan with /cart/change.js and re-renders the drawer.
 * Markup comes from snippets/cart-drawer.liquid ([data-cart-sub-upsell]).
 */
(function () {
  'use strict';

  if (window.__cartSubUpsellLoaded) return;
  window.__cartSubUpsellLoaded = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-cart-sub-upsell]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var drawer = document.querySelector('cart-drawer');
    var errorBox = document.getElementById('CartDrawer-CartErrors');
    var changeUrl = (window.routes && window.routes.cart_change_url) || '/cart/change';

    button.disabled = true;
    button.classList.add('is-loading');

    fetch(changeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: parseInt(button.getAttribute('data-line'), 10),
        quantity: parseInt(button.getAttribute('data-quantity'), 10),
        selling_plan: parseInt(button.getAttribute('data-selling-plan'), 10),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Cart update failed');
          return data;
        });
      })
      .then(function (state) {
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.reload();
        }
        document.dispatchEvent(new CustomEvent('cart:subscription-upsell', { detail: { line: button.getAttribute('data-line') } }));
      })
      .catch(function (error) {
        console.warn('[cart-subscribe-upsell]', error);
        button.disabled = false;
        button.classList.remove('is-loading');
        if (errorBox) errorBox.textContent = (window.cartStrings && window.cartStrings.error) || 'Something went wrong. Please try again.';
      });
  });
})();
